export default "__VITE_ASSET__0722a861__"